import { render } from "./PlotCard.vue?vue&type=template&id=38458332&scoped=true&ts=true"
import script from "./PlotCard.vue?vue&type=script&lang=ts"
export * from "./PlotCard.vue?vue&type=script&lang=ts"

import "./PlotCard.vue?vue&type=style&index=0&id=38458332&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38458332"]])

export default __exports__